import r2wc from '@r2wc/react-to-web-component';
import { StatsigProvider } from '@statsig/react-bindings';

import { useEssentialProps } from '../../../apps/explore/components/AppWrapper/_app.hooks';
import { AmeliaProvider } from '../../../apps/explore/providers/AmeliaProvider';
import { MarketProvider } from '../../../apps/explore/providers/MarketProvider';
import { RedirectProvider } from '../../../apps/explore/providers/RedirectProvider';
import { TranslationProvider } from '../../../apps/explore/providers/TranslationProvider';
import { UserProvider } from '../../../apps/explore/providers/UserProvider';
import { getMarket } from '../../../apps/explore/utils/markets';
import { Content } from './components/Content';
import {
  DEFAULT_SEMBO_MARKET,
  TRIP_PLANNER_EXTRA_QUERY_PARAMS_MAP,
} from './constants';
import { useStatsigClient } from './hooks';
import { WidgetStyles } from './WidgetStyles';

const StenalineSearchComponent = () => {
  const market = getMarket(window.location.host) ?? DEFAULT_SEMBO_MARKET;
  const tripPlannerExtraQueryParams =
    TRIP_PLANNER_EXTRA_QUERY_PARAMS_MAP[window.location.host];
  const { microcopy } = useEssentialProps({ market });
  const { client } = useStatsigClient(market);

  if (!microcopy) {
    return null;
  }

  return (
    <MarketProvider market={market}>
      <StatsigProvider client={client}>
        <UserProvider>
          <TranslationProvider microcopy={microcopy} lang={market.lang}>
            <RedirectProvider isExternal>
              <AmeliaProvider>
                <WidgetStyles />

                <Content
                  tripPlannerExtraQueryParams={tripPlannerExtraQueryParams}
                />
              </AmeliaProvider>
            </RedirectProvider>
          </TranslationProvider>
        </UserProvider>
      </StatsigProvider>
    </MarketProvider>
  );
};

customElements.define(
  'stenaline-search-component',
  r2wc(StenalineSearchComponent, {})
);
